import "./AsideNavigation.scss";
import { List, ListItemButton, ListItemText, ListItemIcon, Grid } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link } from "../../models/app-data-model";

import React from 'react';

export type AsideNavigationProps = {
  navLinks: Link[];
};

export const AsideNavigation: React.FC<AsideNavigationProps> = ({ navLinks }) => {
  return <List component="nav" className='aside-nav' aria-label="List navigation items">
    {
      navLinks.map((navLink, index) =>
        <ListItemButton divider
          component="a"
          disableGutters
          href={navLink.url}
          key={index}
        >
          <ListItemText primary={navLink.title} />
          <ListItemIcon>
            <ChevronRightIcon />
          </ListItemIcon>
        </ListItemButton>
      )}
  </List>
};

export default AsideNavigation;
